import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ProductsService } from '../../../data-access/src/lib/products.service';
import { map } from 'rxjs/operators';
import { Module } from '../../../domain/src/lib/products.model';
import {
  ConfiguracionRolService,
  EstadoDeTrabajoService,
  TokenBridgeService,
  guardarContextoDeProducto,
} from '@nebula-shared/data-access';

export const productsGuard: CanActivateFn = (_route, _state) => {
  const productsService = inject(ProductsService);
  const router = inject(Router);
  const tokenBridge = inject(TokenBridgeService);
  const estadoDeTrabajo = inject(EstadoDeTrabajoService);
  const configuracionRol = inject(ConfiguracionRolService);

  return productsService.getModules().pipe(
    map((data: Module[]) => {
      const getCleanRoute = (item: Module) => {
        const rawRoute = item.route || '';
        const cleanRoute = rawRoute.replace(/^\/+|\/+$/g, '');
        return cleanRoute || item.name.toLowerCase().replace(/\s+/g, '-');
      };

      const modulesLength = data.length;
      const hasMultipleModules = modulesLength > 1;

      tokenBridge.setHasMultipleModules(hasMultipleModules);

      if (data.length === 1) {
        const singleModule = data[0];
        const singleRoute = getCleanRoute(singleModule);

        if (singleModule.id !== undefined && singleModule.id !== null) {
          guardarContextoDeProducto('selectedProductId', singleModule.id.toString());
        }
        // El codigo viaja con el producto: los parametros de configuracion se piden por el.
        configuracionRol.fijarProductoActivo(singleModule.code);

        if (singleModule.name) {
          // La ruta limpia, como el selector (products.component): el menu arma con ella sus rutas.
          guardarContextoDeProducto('selectedRoute', singleRoute);
        }

        const selectedModuleInfo = {
          id: singleModule.id,
          name: singleModule.name,
          route: singleModule.route,
          icon: singleModule.icon,
          description: singleModule.description,
          cleanRoute: singleRoute,
        };
        guardarContextoDeProducto('selectedModule', JSON.stringify(selectedModuleInfo));

        tokenBridge.updateCookie();

        // Con un solo producto, llegar aqui ES entrar a el: desde cero, como desde el selector.
        estadoDeTrabajo.entrarDesdeCero(`/layout/${singleRoute}`);
        return false;
      }

      if (data.length > 1) {
        tokenBridge.updateCookie();
        return true;
      }

      return router.parseUrl('/layout/');
    }),
  );
};
